import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProfileQuery } from '~/QueryHooks/ProfileQuery'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'

const NotificationsPage: React.FC = () => {
  const { t } = useTranslation()
  const [dataFiltered, setDataFiltered] = useState({
    rows: 20,
    page: 0
  })
  const tableColumnHeaders = [
    {
      name: t('Created at'),
      key: 'createdAt',
      type: 'date',
      format: 'DD.MM.YYYY HH:mm'
    },
    {
      name: t('Description'),
      key: 'description'
    },
    {
      name: t('Read at'),
      key: 'readAt',
      type: 'date',
      format: 'DD.MM.YYYY HH:mm'
    }
  ]

  const {
    data: notifications,
    isLoading: isLoadingNotifications,
    refetch: refetchNotifications,
    isFetching: isFetchingNotifications
  } = ProfileQuery.getNotifications({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    refetchNotifications()
  }, [dataFiltered, t])

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingNotifications}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      total={filtered}
    />
  }

  const { filtered, rows } = notifications ? notifications : { filtered: 0, rows: [] };

  return <Layout
    title={t('Notifications')}
    segmented
    isBusy={isLoadingNotifications}
  >
    {renderTable()}
  </Layout>
}
export default NotificationsPage